import { Icon } from "@blueprintjs/core"
import React, { useState } from "react"

import styles from "./SmartMatchingScoreFilter.module.css"

import { Popover2 } from "~/common/Popover2"
import Checkbox from "~/common/SuperSearch/Filters/common/Checkbox"

import { SCORE_LEVELS, ScoreLevel } from "./helpers"

type Props = {
  selectedScoreLevels: ScoreLevel[]
  onSelectionChange: (levels: ScoreLevel[]) => void
}

const SmartMatchingScoreFilter = ({
  selectedScoreLevels,
  onSelectionChange,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const selectedLabels = selectedScoreLevels
    .map((level) => SCORE_LEVELS.find((sl) => sl.value === level)?.label)
    .filter(Boolean)
    .join(", ")

  const handleToggleLevel = (level: ScoreLevel) => {
    if (selectedScoreLevels.includes(level)) {
      onSelectionChange(selectedScoreLevels.filter((l) => l !== level))
    } else {
      onSelectionChange([...selectedScoreLevels, level])
    }
  }

  return (
    <Popover2
      isOpen={isOpen}
      onInteraction={setIsOpen}
      placement="bottom-start"
      content={
        <div className={styles.container}>
          <div>
            {SCORE_LEVELS.map((scoreLevel) => {
              const id = `score-level-${scoreLevel.value}`
              return (
                <label
                  key={scoreLevel.value}
                  className={styles.menuItem}
                  htmlFor={id}
                >
                  <span className={styles.label}>{scoreLevel.label}</span>
                  <Checkbox
                    id={id}
                    checked={selectedScoreLevels.includes(scoreLevel.value)}
                    onChange={() => handleToggleLevel(scoreLevel.value)}
                    className={styles.checkbox}
                  />
                </label>
              )
            })}
          </div>
        </div>
      }
    >
      <button
        className={styles.triggerLabel}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-label={`Filter by score levels. Currently showing: ${selectedLabels || "all results"}`}
      >
        <span className={styles.staticText}>Showing results:</span>
        <span>{selectedLabels || "(none)"}</span>
        <Icon icon="caret-down" className={styles.arrow} />
      </button>
    </Popover2>
  )
}

export default SmartMatchingScoreFilter
